export default {
  accepted: {
    title: '서명 완료',
    description: '서명이 완료되었습니다. 저희 배송 서비스를 이용해 주셔서 감사합니다!',
  },
  info: '배송이 있습니다:',
  title: '정보를 확인해 주세요:',
  fields: {
    name: '수취인 이름:',
    phone: '수취인 전화번호:',
    address: '수취인 주소:',
    'rx-number': '처방전 번호:',
  },
  'action-btn': '제출',
  'empty-signature': '제출 전에 서명을 해주세요.',
}
